// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__74euf","subheader":"ReorderModal_subheader__1G-zD","listWrap":"ReorderModal_listWrap__2fs-q"};